import template from './sw-cms-block-text-on-image.html.twig';
import './sw-cms-block-text-on-image.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
